export const customerClaimsFilterState = () => ({
  searchKey: '',
  status: 'all',
  year: null,
  product: null,
  page: 1,
  perPage: 10,
  orderBy: 'updatedAt',
  order: 'desc'
});
